<template>
  <div class="history ">
    <div class="font10 left4" >
      <span class="">
        {{name}}：-
      </span>
    </div>
  </div>
</template>
<script>
export default {
    props:{
        name:{
            Object:String,
            default :""
        }
    }
}
</script>
